import { connect } from 'react-redux';
import LandingPage from './LandingPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { initiateLogin } from '../../actions/userAction';

import { 
    saveEidNumber, 
    notValidDevice, 
    saveIccidNumber, 
    saveIccidNumbers,
    updateIsMultipleIccids
} from '../../actions/basicAction';

export const mapStateToProps = (state: AppState) => {
    return {
        btnElement: 'Sign-in to Troubleshoot',
        btnType: 'signin'
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onSubmit: () => {
            // dispatch(fetchCurrentUser);
            dispatch(initiateLogin);            
        },
        onComponentDidMount:  (url: string) => {
            const paramsString = url.split('?' )[1];

            const params = new URLSearchParams( paramsString );
            const eidNumber = params.get('eid') || '';
            const iccidNumbers = params.get('iccids') || '';
            let iccidNumber = '';            
            if (eidNumber === undefined || eidNumber === 'undefined' || eidNumber === '') {
                dispatch(notValidDevice);
            }
            dispatch(saveEidNumber(eidNumber));
            if (iccidNumbers.indexOf(',') === -1 ) {
                iccidNumber = iccidNumbers;
                dispatch(updateIsMultipleIccids(false));
                dispatch(saveIccidNumber(iccidNumber));
            } else {
                dispatch(updateIsMultipleIccids(true));
                dispatch(saveIccidNumbers(iccidNumbers));
            }
        }
    };
};

const LandingPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LandingPage);

export default LandingPageContainer;



// WEBPACK FOOTER //
// ./src/components/landingPage/LandingPageContainer.tsx